/**
 * Product Countdown Timer
 * Displays days remaining until sale end date from product metafield
 */
class ProductCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = this.getAttribute('data-end-date');
    this.productId = this.getAttribute('data-product-id');
    this.daysElement = this.querySelector('.countdown-days');
    this.standardDisplay = this.querySelector('.countdown-standard');
    this.todayDisplay = this.querySelector('.countdown-today');
    this.badge = this.querySelector('.badge--countdown');
    this.interval = null;
    
    if (this.endDate && this.daysElement && this.standardDisplay && this.todayDisplay) {
      this.startCountdown();
    }
  }

  startCountdown() {
    // Initial update
    this.updateCountdown();
    
    // Update every second
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const end = new Date(this.endDate).getTime();
    const distance = end - now;

    // If countdown is finished, hide the timer
    if (distance < 0) {
      this.hideTimer();
      return;
    }

    // Calculate days remaining
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    
    // Update display based on days remaining
    if (days === 0) {
      // Show "Sale Ends Today"
      this.standardDisplay.style.display = 'none';
      this.todayDisplay.style.display = 'inline';
    } else {
      // Show "X Days Left"
      this.standardDisplay.style.display = 'inline';
      this.todayDisplay.style.display = 'none';
      this.daysElement.textContent = days;
    }
  }

  hideTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.style.display = 'none';
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

customElements.define('product-countdown-timer', ProductCountdownTimer);